/**
 * @file shared.module.ts
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgxMaskModule } from 'ngx-mask';

import { MaterialModule } from '@core/modules';
import {
  ClaimDetailComponent,
  CommonConfirmationPopupComponent,
  DowntimeDialogComponent,
  MailOrderProfilePendingComponent,
  NewAddressComponent,
  NewCreditCardComponent,
  OrderDetailsComponent,
  MailOrderPatientEnrollmentFormComponent,
  PrescriptionDetailComponent,
  RecentOrderComponent,
  RequestHistoricalDataPopupComponent,
  UpdateMailOrderProfileDialogComponent,
  PharamacySsoRedirectionComponent,
} from './components';
import { PipesModule } from './pipes';
import { SharedRoutingModule } from './shared-routing.module';
import { DIRECTIVES } from './directives';

@NgModule({
  declarations: [
    PrescriptionDetailComponent,
    OrderDetailsComponent,
    ClaimDetailComponent,
    RecentOrderComponent,
    NewAddressComponent,
    NewCreditCardComponent,
    DowntimeDialogComponent,
    UpdateMailOrderProfileDialogComponent,
    RequestHistoricalDataPopupComponent,
    CommonConfirmationPopupComponent,
    MailOrderProfilePendingComponent,
    MailOrderPatientEnrollmentFormComponent,
    PharamacySsoRedirectionComponent
  ],
  imports: [
    CommonModule,
    SharedRoutingModule,
    FormsModule,
    MaterialModule,
    NgxMaskModule,
    ReactiveFormsModule,
    PipesModule,
    DIRECTIVES
  ],
  exports: [RecentOrderComponent, MailOrderProfilePendingComponent,PharamacySsoRedirectionComponent, PipesModule],
})
export class SharedModule {}
